import styled from 'styled-components';

export default styled.footer`
align-self: center;
margin-top: auto;
`;
